export class Invitation {
  id: number;
  expiresAt: number;
  invitationToken: string;
  studyTitle: string;
  studyDescription?: string;
  studyImageUrl?: string;

  constructor(id: number, expiresAt: number, invitationToken: string, studyTitle: string, studyDescription?: string, studyImageUrl?: string) {
    this.id = id;
    this.expiresAt = expiresAt;
    this.invitationToken = invitationToken;
    this.studyTitle = studyTitle;
    this.studyDescription = studyDescription;
    this.studyImageUrl = studyImageUrl;
  }
}
